import { useCallback, useState } from "react";

import { SESSION_STORAGE } from "@/constants";

type TraceId = string | null | undefined;

const readStoredId = (): string | null => {
  try {
    const raw = sessionStorage.getItem(SESSION_STORAGE.RECENTLY_VIEWED_TRACE_ID);
    return raw && raw.length > 0 ? raw : null;
  } catch {
    return null;
  }
};

export const useRecentlyViewedTraceSession = () => {
  const [recentlyViewedTraceId, setRecentlyViewedTraceId] = useState<string | null>(() =>
    readStoredId(),
  );

  const markRecentlyViewedTrace = useCallback((id: TraceId) => {
    if (!id) {
      return;
    }

    try {
      sessionStorage.setItem(SESSION_STORAGE.RECENTLY_VIEWED_TRACE_ID, id);
    } catch {
      // ignore quota / private mode
    }
    setRecentlyViewedTraceId(id);
  }, []);

  return { recentlyViewedTraceId, markRecentlyViewedTrace };
};
